<template lang="pug">
    include DashboardResources.pug
</template>

<script>
import Api from "@/components/services/Api";
import Notification from "./Notification";
import Announcement from "./Announcement";
import DashboardCard from "./DashboardCard";

export default {
  name: 'DashboardResources',
  components: {Notification, Announcement, DashboardCard},
  data() {
    return {
      user: null,
      visible: false,
      announcements: [],
      notifications: [],
    }
  },
  created() {
    const _this = this;

    Api.me(this.$store.state.token).then(result => {
      let hasLopd = result.data.lopd

      if (hasLopd) {
        // If it is not a professional we must redirect to school
        _this.user = result.data;
        _this.announcements = result.data.announcements;
        _this.notifications = result.data.notifications;
        _this.visible = true;
      } else {
        _this.$router.push({
          name: "Lopd",
        });
      }
    }).catch(err => {
      // TODO: Manage error
    });
  }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "Dashboard";
@import "DashboardResources";
</style>




// WEBPACK FOOTER //
// src/components/dashboard/DashboardResources.vue